import { useState, useEffect } from 'react';

const useLanguage = (translationsEnabled = false, availableLanguages = []) => {
  const [languageCode, setLanguageCode] = useState(() => {
    if (!translationsEnabled) {
      return 'it';
    }

    const storedLanguage = localStorage.getItem('selectedLanguage');
    if (storedLanguage) {
      return storedLanguage;
    }

    const browserLanguage = (navigator.language || navigator.userLanguage)
      ?.toLowerCase()
      .substring(0, 2);
    console.log(`Browser language: ${browserLanguage}`);

    if (availableLanguages.some(lang => lang.code === browserLanguage)) {
      return browserLanguage;
    }

    return 'en';
  });

  useEffect(() => {
    if (translationsEnabled && languageCode) {
      localStorage.setItem('selectedLanguage', languageCode);
      console.log(`Translation updated: ${languageCode}`);
    }
  }, [languageCode, translationsEnabled]);

  return { languageCode, setLanguageCode };
};

const useLanguageReadOnly = () => {
  const [languageCode, setLanguageCode] = useState(() => {
    const storedLanguage = localStorage.getItem('selectedLanguage');
    return storedLanguage || 'it';
  });

  // Effetto per aggiornare la lingua se cambia nel localStorage (ad esempio, da un'altra pagina)
  useEffect(() => {
    const handleStorageChange = event => {
      if (event.key === 'selectedLanguage') {
        setLanguageCode(event.newValue);
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  return languageCode;
};

export { useLanguage, useLanguageReadOnly };
